import React, { useEffect } from 'react'
import Header from '../../../headerone/Main'
import Bredcom from '../../../Bredcom/Main'
import VeteransHousingAssistanceDetails from '../../subdepartmentdetails/VeteransHousingAssistance'


function VeteransHousingAssistance() {

  useEffect(() => {
    document.getElementById("title").innerHTML="Veteran Housing Assistance and Homelessness Prevention || Veterans Affairs";
  }, [])


  return (
    <>
        {/* Header is now rendered at app level in routes/index.js to prevent remounting on navigation */}

        <div className="page-wrapper">
        <Bredcom 
            subtitle="Veterans Affairs"
            title="Veterans Housing Assistance"
            subtitledown="Department of Veterans Affairs"
           />
            <VeteransHousingAssistanceDetails/>
        </div>
    </>
  )
}

export default VeteransHousingAssistance